import cn from "classnames";
import styles from "./styles.module.scss";

export const ImpactBoxes = ({ className, items }) => {
  return (
    <section className={cn(styles.ImpactBoxes, className)}>
      <div className={styles.bgDecor} />
      <div className={styles.inner}>
        {items?.map((item, idx) => (
          <div key={idx} className={cn(styles.row, { [styles.reversed]: idx % 2 !== 0 })}>
            <div className={styles.imageWrapper}>
              <img src={item.image?.url || "https://placehold.co/575x500"} alt="" className={styles.image} />
            </div>
            <div className={styles.content}>
              <h2
                className={styles.title}
                dangerouslySetInnerHTML={{ __html: item.title }}
                data-sourceflow-prop={`items[${idx}].title`}
              />
              <div
                className={styles.desc}
                dangerouslySetInnerHTML={{ __html: item.description }}
                data-sourceflow-prop={`items[${idx}].description`}
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ImpactBoxes;
